export const environment = {
  production: true,
  activate: {
    baseURL: 'https://n7o5muzaokzulbgv3gcdl675740vntjh.lambda-url.us-east-1.on.aws/phoneactivation',
    redirectUrl: 'https://admin.asksuite.com/phone-activation-success',
  }
}
